module.exports = __webpack_public_path__ + "img/sr03_samurai02skin_shop.08a4ff90.png";